import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { Campo, Resposta } from "../../../models/coleta";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { AppValidators } from "../util/validators";
import { Form } from "../../../models/app-state";
import { INPUT_TYPES, PROPRIEDADES } from "../util/constants";
import { AppFlowService } from "../../../services/app-flow.service";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { FormatService } from "src/app/services/format.service";
import { SessionStorageService } from "src/app/services/session-storage.service";

@Component({
  selector: "app-dynamic-input",
  templateUrl: "./dynamic-input.component.html",
  styleUrls: ["./dynamic-input.component.scss"],
})
export class DynamicInputComponent implements OnInit, OnChanges {

  selectedType: string = '';

  readonly INPUT_TYPES = INPUT_TYPES;

  internalCampo: Campo = {};
  isHidden = false;
  isAttachment = false;
  isSelfie = false;

  inputType = "";

  required = false;

  readOnly = false;

  defaultValue: any;

  @Input()
  isCepLoading = false;

  @Input()
  formGroup!: UntypedFormGroup;

  @Input()
  showLabel = true;

  @Input()
  requestFocus = false;

  @Input()
  form: Form = {};

  @Output()
  onLoadingCep: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private appFlowService: AppFlowService,
    private dbService: NgxIndexedDBService,
    private formatService: FormatService,
    private sessionStorageService: SessionStorageService
  ) {}

  get campo(): Campo {
    return this.internalCampo;
  }

  isTrue(value: string | boolean | undefined): boolean {
    return value === true || value === "true";
  }

  @Input()
  set campo(campo: Campo) {
    this.inputType = campo.tipo || "";
    const hasOptions = (campo.opcoes?.length || -1) > 0;
    const dropdownInputs = [
      INPUT_TYPES.TEXT,
      INPUT_TYPES.INTEGER,
      INPUT_TYPES.NUMERIC,
    ];
    if (hasOptions && dropdownInputs.indexOf(this.inputType) > -1) {
      this.inputType = INPUT_TYPES.SELECT_OPTIONS;
    }
    this.internalCampo = campo;
    const hiddenAttr = campo.atributos?.find(
      (item) => item && item.propriedade === "OCULTO"
    );
    this.isHidden = (hiddenAttr && hiddenAttr.valor === "true") || false;
    this.readOnly = this.isTrue(
      campo.atributos?.find(
        (item) => item.propriedade === PROPRIEDADES.SOMENTE_LEITURA
      )?.valor
    );
    this.isAttachment = this.isTrue(
      campo.atributos?.find(
        (item) => item.propriedade === PROPRIEDADES.MODO_ENTRADA
      )?.valor === "anexo"
    );
    this.required =
      !this.isHidden &&
      this.isTrue(
        campo.atributos?.find(
          (item) => item.propriedade === PROPRIEDADES.OBRIGATORIEDADE
        )?.valor
      );
    this.defaultValue = campo.atributos?.find(
      (item) => item.propriedade === PROPRIEDADES.VALOR_PADRAO
    )?.valor;
  }

  get isInputText(): boolean {
    if (this.isInputOtp) {
      return false;
    }
    
    switch (this.inputType) {
      case INPUT_TYPES.NUMBER:
      case INPUT_TYPES.TEXT:
      case INPUT_TYPES.INTEGER:
      case INPUT_TYPES.ALFANUMERICO:
      case INPUT_TYPES.DECIMAL:
      case INPUT_TYPES.ALPHA:
        return true;
      default:
        return false;
    }
  }

  get isInputDropdown(): boolean {
    switch (this.inputType) {
      case INPUT_TYPES.SELECT_OPTIONS:
        return true;
      default:
        return false;
    }
  }

  get isInputDate(): boolean {
    switch (this.inputType) {
      case INPUT_TYPES.DATE:
        return true;
      default:
        return false;
    }
  }

  get isInputCheckbox(): boolean {
    switch (this.inputType) {
      case INPUT_TYPES.BOOL:
        return true;
      default:
        return false;
    }
  }

  get isInputImage(): boolean {
    switch (this.inputType) {
      case INPUT_TYPES.IMAGE:
        this.isSelfie = !!this.campo.codigo?.includes("face");
        return true;
      default:
        return false;
    }
  }

  get isInputOtp(): boolean {
    return this.campo.codigo === 'termo.aceite.token.sms';
  }

  get currentFormControl(): UntypedFormControl {
    if (this.campo?.codigo) {
      const formControl = this.formGroup.controls[this.campo.codigo];
      return formControl as UntypedFormControl;
    }
    return new UntypedFormControl();
  }

  addFormControl() {
    if (this.campo?.codigo) {
      let formControl = this.formGroup.controls[this.campo.codigo];

      if (!formControl) {
        const respostas: Resposta[] | undefined =
          this.appFlowService.getRespostasByCampo(this.campo.codigo);
        let fieldValue;

        // const currentPage = this.appFlowService.getCurrentStepName();
        //  fieldValue = this.form[currentPage]?.value[this.campo.codigo]?.valor;
            
        if (this.campo.tipo == INPUT_TYPES.BOOL) {
          fieldValue = fieldValue === "true";
        }

        if (this.campo.tipo && respostas) {
          fieldValue = respostas.sort((a, b) => a.ordem - b.ordem)[0].valor;

          if (this.campo.tipo === INPUT_TYPES.IMAGE) {
            const base64 = fieldValue;
            const id = this.campo.codigo || "";
            const isPdf = respostas.sort((a, b) => a.ordem - b.ordem)[0].pdf;
            this.dbService
              .update("images", { base64, id, isPdf })
              .toPromise()
              .then((res) => res);
          }
        }

        if (this.defaultValue != null) {
          fieldValue = this.defaultValue;

          if (this.campo.tipo == INPUT_TYPES.BOOL) {
            fieldValue = this.defaultValue === "true";
          }
        }

        const validations = AppValidators.getValidations(this.campo);


        
        const documentoReanalise = this.sessionStorageService.getEnvConfig()?.consultaExternaConfig?.documentoCliente;
        if (this.campo.codigo == "pessoa.cpf" && documentoReanalise) {
          fieldValue = documentoReanalise;
          this.readOnly = true;
        }

        formControl = new UntypedFormControl(
          fieldValue ? fieldValue : null,
          validations
        );
        this.formGroup.addControl(this.campo.codigo, formControl);

      }
  }
}

  /* Caso o campo pai tenha dependencia de outro campo pai.
  Atualmente funcionando apenas para obrigatoriedade.

  Detalhe: Já existia o componente dependencies-group, no entanto, 
  funciona apenas para dependencias entre campos pais e filhos, 
  para o atributo de campos dependentes ocultos.
  */
  handleCamposPaisDependencies() {
    if (!this.campo.dependentes) return;

    const dependentes = this.campo.dependentes;

    const allFields = this.appFlowService.getAppState().fieldsAsObject;

    if (!this.formGroup.controls[this.campo.codigo || ""]) return;

    const campoPaiConvertidoEmForm =
      this.formGroup.controls[this.campo.codigo || ""];

    campoPaiConvertidoEmForm.valueChanges.subscribe((valueChange) => {
      dependentes.forEach((campoDependente) => {
        if (!this.formGroup.controls[campoDependente.campoDependenteCodigo])
          return;
        const campoDependenteConvertidoEmForm =
          this.formGroup.controls[campoDependente.campoDependenteCodigo];
        let campoDependenteSmilegoObject =
          allFields[campoDependente.campoDependenteCodigo];

        //Se o campo dependente, tiver propriedade de oculto, será tratado no componente dependencies-group.
        if (
          !campoDependenteSmilegoObject.atributos ||
          campoDependenteSmilegoObject.atributos.some(
            (atributo) => atributo.propriedade === "OCULTO"
          )
        )
          return;

        if (campoDependente.acao === "OBRIGAR") {
          if (valueChange) {
            campoDependenteSmilegoObject.atributos?.push({
              id: 17,
              propriedade: "OBRIGATORIEDADE",
              configuracao: "comum",
              valor: "true",
            });
          } else {
            campoDependenteSmilegoObject.atributos =
              campoDependenteSmilegoObject.atributos.filter(
                (atributo) => atributo.propriedade !== "OBRIGATORIEDADE"
              );
          }

          //atualiza os validadores no forms do angular.
          campoDependenteConvertidoEmForm.setValidators(
            AppValidators.getValidations(campoDependenteSmilegoObject)
          );
          campoDependenteConvertidoEmForm.updateValueAndValidity();

          //Manda a mensagem para que os outros campos pais possam atualizar o atributo de required.
          this.appFlowService.fieldsChangedObservable.next(
            campoDependente.campoDependenteCodigo
          );
        }
      });
    });
  }

  //Força a atualização do logradouro no formControl toda vez que houver uma mudança.
  onChangesReloadCep() {
    const fieldsToReload: string[] = [
      "pessoa.endereco.logradouro",
      "pessoa.endereco.cidade",
      "pessoa.endereco.uf.sigla",
      "pessoa.endereco.bairro",
    ];

    const currentField = this.campo?.codigo || "";

    if (fieldsToReload.includes(currentField)) {
      const formControl = this.formGroup.controls[currentField];

      if (formControl) {
        const currentPage = this.appFlowService.getCurrentStepName();
        const fieldValue = this.form[currentPage]?.value[currentField]?.valor;

        formControl.setValue(fieldValue);
      }
    }
  }

  ngOnInit(): void {
    this.addFormControl();
    this.handleAutoCompleteCep();
    this.handleCamposPaisDependencies();
    this.appFlowService.fieldsChangedObservable.subscribe((campoCodigo) => {
      if (this.campo.codigo !== campoCodigo) return;
      this.required = !this.required;
    });
  }

  handleAutoCompleteCep() {
    if (this.campo.codigo && this.campo.codigo.endsWith("cep")) {
      this.formGroup.controls[this.campo.codigo].valueChanges.subscribe(
        (addressChanges) => {
          if (
            addressChanges &&
            addressChanges.length === 8 &&
            !this.isCepLoading
          ) {
            this.onLoadingCep.emit(addressChanges);
          }
        }
      );
    }
  }

  ngOnChanges(): void {
    // this.onChangesReloadCep();
  }

  onTypeChange(selectedType: string){

    this.selectedType = selectedType;  
    if (this.campo.codigo == 'pessoa.referencia.telefone.tipo') {
      this.formatService.updateFormatType(selectedType);
    }
    
  }

}
